export default function AtMap()
{
    var keys = [];
    var values = [];
    var size = 0;

    /**
     * @return Integer size of map.
     */
    this.size = function()
    {
        return size;
    };

    /**
     *@return Array all objects in map
     */
    this.getValues = function()
    {
        return removeUndefinedElements(values);
    };

    /**
     * If key already present in map object replaced old object
     * associated with this key otherwise object add to map.
     * @param key key associated with object
     * @param object object added to map
     */
    this.put = function(key, object)
    {
        var realKey = createKey(key);
        var index = values.length;
        if (keys[realKey] != undefined)
        {
            index = keys[realKey];
        }
        keys[realKey] = index;
        values[index] = object;
        size++;
    };

    /**
     * @param key
     * @return object associated with key or null if key not found in map.
     */
    this.get = function(key)
    {
        var realKey = createKey(key);
        var index = keys[realKey];
        return values[index];
    };

    /**
     * This method delete object associated with key and return object
     * @param key
     * @return object associated with key or null if key not found.
     */
    this.remove = function(key)
    {
        var realKey = createKey(key);
        var index = keys[realKey];
        var result = null;
        if (index != undefined)
        {
            result = values[index];
            delete values[index];
            delete keys[realKey];
            size--;
        }
        return result;
    };

    /**
     *
     * @param objectsArray data to create map.
     * @param keyGenerator keyGenerator for create keys from objects.
     */
    this.addArrayToMap = function(objectsArray, keyGenerator)
    {
        for (var i = 0; i < objectsArray.length; i++)
        {
            var object = objectsArray[i];
            this.put(keyGenerator.createKey(object), object);
        }
    };

    //private methods
    function removeUndefinedElements(array)
    {
        var result = [];
        for (var i = 0; i < array.length; i++)
        {
            if(array[i] != undefined)
            {
                result.push(array[i]);
            }
        }
        return result;
    }

    //workaround: if send integer key  when put data to Map Array class create index instead key.
    //That why all keys should be string type.
    function createKey(string)
    {
        return "key:" + string;
    }
}


// WEBPACK FOOTER //
// ./web/js/util/AtMap.js